// Copyright (c) 2019, Oracle and/or its affiliates. All rights reserved.
// Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.

define('C3.ShoppingExtensions.NewArrivals.Router'
, [
    'Backbone'

  , 'C3.ShoppingExtensions.NewArrivals.View'
  , 'C3.ShoppingExtensions.NewArrivals.Model'
  , 'C3.ShoppingExtensions.NewArrivals.Collection'
  ,  'Utils'
  ]
, function
  (
    Backbone

  , View
  , Model
  , Collection
  ,  Utils
  )
{
  'use strict';

  return Backbone.Router.extend ({
    routes:
    {
      'new-arrivals': 'list'
    }

  , initialize: function (application)
    {
     // console.log(application)
      this.application = application;
      this.configuration = application.Configuration;
    }

  , list: function (options)
    {
      var model = new Model()
        , self = this;


     options = (options) ? Utils.parseUrlOptions(options) : {page: 1};
      options.page = options.page || 1;    

     var collection = new Collection()   
      var view = new View
        ({
             application: this.application
        ,   collection : collection       
        ,   pageNumber: options.page
        ,  configuration : this.configuration
        });

      collection.fetch({ data:{       
        pageNumber: options.page,
        resultsPerPage: 50,
        filters: ''
      } }).done(function(res) {
     // console.log(res) 
        view.showContent();
      });
    }
  })
});
